<template>
  <b-modal
    v-model="showModal"
    centered
    header-class="custom-modal-header"
    footer-class="custom-modal-footer"
  >
    <template #modal-header>
      <p class="text-header">{{ title }}</p>
    </template>
    <b-form>
      <b-row>
        <b-col md="12">
          <InputText
            textFloat="Name"
            placeholder="Name"
            type="text"
            name="name"
            isRequired
            v-model="form.name"
            :isValidate="$v.form.name.$error"
            :v="$v.form.name"
          />
        </b-col>
        <b-col md="12">
          <InputNumber
            textFloat="From"
            placeholder="From"
            type="text"
            name="from"
            isRequired
            v-model="form.from"
            :isValidate="$v.form.from.$error"
            :v="$v.form.from"
          />
        </b-col>
        <b-col md="12">
          <InputNumber
            textFloat="To"
            placeholder="To"
            type="text"
            name="to"
            isRequired
            v-model="form.to"
            :isValidate="$v.form.to.$error"
            :v="$v.form.to"
          />
        </b-col>
        <b-col md="12">
          <InputNumber
            textFloat="Score"
            placeholder="0"
            name="score"
            v-model="form.score"
            isRequired
            :isValidate="$v.form.score.$error"
            :v="$v.form.score"
          />
        </b-col>
      </b-row>
    </b-form>
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <button class="cancel-button" @click="onCloseModal">ยกเลิก</button>
        <button class="save-button" @click="onSubmit()">บันทึก</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputNumber from "@/components/inputs/InputNumber";
import { required, integer } from "vuelidate/lib/validators";
export default {
  name: "SettingWordModal",
  components: {
    InputText,
    InputNumber,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showModal: false,
      form: {
        id: "",
        name: "",
        from: "",
        to: "",
        score: "",
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
      },
      from: {
        required,
      },
      to: {
        required,
      },
      score: {
        required,
        integer,
      },
    },
  },
  watch: {
    selectedItem() {
      this.form = this.selectedItem;
    },
    showModal() {
      if (!this.showModal) {
        this.$emit("onCloseModal");
      }
    },
  },
  methods: {
    onCloseModal() {
      this.showModal = false;
      this.$v.form.$reset();
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }
      this.$emit("onSaveModal", this.form);
    },
  },
};
</script>

<style lang="scss" scoped></style>
